import { gql } from '@apollo/client';

export const LOG_LIST_QUERY = gql`
  query logs($pager: PagerInput!, $filters: LogFilterInput) {
    logs(pager: $pager, filters: $filters) {
      total
      values {
        id
        message
        level
        timeStamp
        exception
        logEvent
        correlationId
      }
    }
  }
`;

export const LOG_QUERY = gql`
  query log($logId: String!) {
    log(logId: $logId) {
      id
      message
      level
      timeStamp
      exception
      logEvent
      correlationId
    }
  }
`;

export const LOG_LEVELS_QUERY = gql`
  query logLevels {
    logLevels {
      id
      name
    }
  }
`;
export const GENERIC_FILTER_PARAM_LOGS = gql`
  query genericFilterParamLogs($pager: PagerInput!, $filters: GenericFilterParamLogsFilterInput!) {
    genericFilterParamLogs(pager: $pager, filters: $filters) {
      total
      values {
        id
        documentType {
          id
          name
        }
        logDate
        method
        operator
        partnerId
        siteId
        partnerId
        documentNumber
      }
    }
  }
`;

export const GENERIC_FILTER_PARAM_LOG_XML_CONTENT_QUERY = gql`
  query genericFilterParamLogXmlContent($id: Int!) {
    genericFilterParamLogXmlContent(id: $id) {
      id
      xmlContents
    }
  }
`;

export const DOCUMENT_TYPES_QUERY = gql`
  query documentTypes {
    documentTypes {
      id
      code
      name
    }
  }
`;

export const EVALUATION_LOGS = gql`
  query evaluationLogs($pager: PagerInput!, $filters: EvaluationLogsFilterInput!) {
    evaluationLogs(pager: $pager, filters: $filters) {
      total
      values {
        id
        entity_PK1
        entity_PK2
        entityType
        timeUtc
        additionalInfo
        source
        correlationID
      }
    }
  }
`;

export const EVALUATION_LOG_XML_DATA_QUERY = gql`
  query evaluationLogXmlData($id: ID!) {
    evaluationLogXmlData(id: $id) {
      id
      inputData
      processData
      executionData
    }
  }
`;
